/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parents_FamilyInputs */

const th_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ปกครองและครอบครัว`)
};

const en_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parents & family`)
};

const ja_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保護者・ご家族`)
};

const zh_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`家长与家人`)
};

const es_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padres y familia`)
};

const pt_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pais e família`)
};

const id_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orang tua dan keluarga`)
};

const fr_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parents et famille`)
};

const tl_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magulang at pamilya`)
};

const vi_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cha mẹ và gia đình`)
};

const ko_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부모와 가족`)
};

const de_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltern und Familie`)
};

const ru_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Родители и семья`)
};

const tr_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ebeveynler ve aile`)
};

const it_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genitori e familiari`)
};

const pl_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodzice i rodzina`)
};

const uk_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Батьки та родина`)
};

const hi_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`माता-पिता और परिवार`)
};

const ar_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأهل والعائلة`)
};

const ms_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ibu bapa dan keluarga`)
};

const bn_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অভিভাবক ও পরিবার`)
};

const zh_tw2_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`家長與家人`)
};

const zh_hk2_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`家長與家人`)
};

const ur_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`والدین اور خاندان`)
};

const fa_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`والدین و خانواده`)
};

const sw_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wazazi na familia`)
};

const nl_parents_family = /** @type {(inputs: Parents_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouders en familie`)
};

/**
* | output |
* | --- |
* | "Parents & family" |
*
* @param {Parents_FamilyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const parents_family = /** @type {((inputs?: Parents_FamilyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parents_FamilyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_parents_family(inputs)
	if (locale === "ja") return ja_parents_family(inputs)
	if (locale === "zh") return zh_parents_family(inputs)
	if (locale === "es") return es_parents_family(inputs)
	if (locale === "pt") return pt_parents_family(inputs)
	if (locale === "id") return id_parents_family(inputs)
	if (locale === "fr") return fr_parents_family(inputs)
	if (locale === "tl") return tl_parents_family(inputs)
	if (locale === "vi") return vi_parents_family(inputs)
	if (locale === "ko") return ko_parents_family(inputs)
	if (locale === "de") return de_parents_family(inputs)
	if (locale === "ru") return ru_parents_family(inputs)
	if (locale === "tr") return tr_parents_family(inputs)
	if (locale === "it") return it_parents_family(inputs)
	if (locale === "pl") return pl_parents_family(inputs)
	if (locale === "uk") return uk_parents_family(inputs)
	if (locale === "hi") return hi_parents_family(inputs)
	if (locale === "ar") return ar_parents_family(inputs)
	if (locale === "ms") return ms_parents_family(inputs)
	if (locale === "bn") return bn_parents_family(inputs)
	if (locale === "zh-TW") return zh_tw2_parents_family(inputs)
	if (locale === "zh-HK") return zh_hk2_parents_family(inputs)
	if (locale === "ur") return ur_parents_family(inputs)
	if (locale === "fa") return fa_parents_family(inputs)
	if (locale === "sw") return sw_parents_family(inputs)
	if (locale === "nl") return nl_parents_family(inputs)
	return en_parents_family(inputs)
});